import {Component, OnDestroy, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {IDatepickerSchema, ToastService} from 'maps-angular-components';
import {Subject, Subscription} from "rxjs";

import {AcaoAuditoria} from "../trilha-auditoria/acao-auditoria";
import {AuditDetalhe} from "../audit-detalhe";
import {Auditoria} from "../auditoria";
import {MatDialog} from "@angular/material/dialog";
import {ModalAlteracoesComponent} from "../modal-alteracoes/modal-alteracoes.component";
import {ModalDetalheAlteracoesComponent} from "../../shared/modal-detalhe-alteracoes/modal-detalhe-alteracoes.component";
import {TrilhaAuditoriaService} from "../trilha-auditoria.service";
import {indicate} from "../../shared/util/loading-indicate";

@Component({
    selector: 'app-trilha-auditoria-pesquisa',
    templateUrl: './trilha-auditoria-pesquisa.component.html',
    styleUrls: ['./trilha-auditoria-pesquisa.component.scss']
})
export class TrilhaAuditoriaPesquisaComponent implements OnInit, OnDestroy {

    private readonly subscriptions = new Subscription();

    data: Auditoria[] = [];
    form: FormGroup;
    auditorias: Auditoria[] = [];
    paginationTotalPage = 1;
    public totalRegistros = 0;
    tiposCadastro = []
    tiposCommit = AcaoAuditoria.values;

    loading$: Subject<boolean> = new Subject<boolean>();

    loadingExport$: Subject<boolean> = new Subject<boolean>();
    page$: Subject<number> = new Subject<number>();

    public dataInicioSchema: IDatepickerSchema;
    public dataFimSchema: IDatepickerSchema;

    constructor(
        private readonly formBuilder: FormBuilder,
        private readonly dialog: MatDialog,
        private readonly messageService: ToastService,
        private readonly auditoriaService: TrilhaAuditoriaService
    ) {
    }

    ngOnInit(): void {
        this.form = this.formBuilder.group({
            tipoCadastro: new FormControl(),
            usuario: new FormControl(),
            acao: new FormControl(),
            dataInicio: new FormControl(),
            dataFim: new FormControl(),
            identificador: new FormControl(),
            descricao: new FormControl(),
            usuarioAutorizacao: new FormControl(),
            itensPerPage: new FormControl(20),
            page: new FormControl(0),
        });

        this.subscriptions.add(this.auditoriaService.findAllTipoCadastro()
        .subscribe(data => this.tiposCadastro = data));

        this.page$.subscribe(value => {
            this.form.controls.page.setValue(value - 1);
            this.pesquisar();
        });

        this.dataInicioSchema = {
            label: "Data início",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            panelClass: "w-100",
            formControlName: "dataInicio"
        };

        this.dataFimSchema = {
            label: "Data fim",
            placeholder: "Selecione uma data",
            formGroup: this.form,
            panelClass: "w-100",
            formControlName: "dataFim"
        };
    }

    pesquisar() {

        this.auditorias = [];
        this.totalRegistros = 0;
        this.subscriptions.add(
            this.auditoriaService
            .search(this.form.value)
            .pipe(indicate(this.loading$))
            .subscribe(
                (r) => {
                    if (r.metadata.totalElements > 0) {
                        if (r.metadata.size === 0) {
                            this.paginationTotalPage = 1;
                        } else {
                            this.paginationTotalPage = Math.ceil(
                                r.metadata.totalElements / r.metadata.size
                            );
                        }
                        this.totalRegistros = r.metadata.totalElements;
                        this.auditorias = r.content.map(e => {
                                const audit = Object.assign(new Auditoria(), e);
                                audit.acao = AcaoAuditoria.fromString(e.acao);
                                return audit;
                            }
                        );
                        this.form.get("page").setValue(r.metadata.number);
                    } else {
                        this.paginationTotalPage = 1;
                    }
                },
                err => {
                    this.messageService.erro(err.error?.message || err.message);
                }
            )
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    receiverPage(value) {
        this.page$.next(value);
    }

    async showDetails(audit: Auditoria) {
        const data = await this.findDetails(audit);
        this.openDialog(audit,data);
    }

    findDetails(audit): Promise<AuditDetalhe>{
        if (audit.acao.id === 'DELETE') {
             return this.auditoriaService.findPreviousDetails(audit.descricao,audit.tipoCadastro).toPromise();
        } else {
            return this.auditoriaService.findDetails(audit.idAuditoria,audit.tipoCadastro).toPromise();
        }
    }

    private openDialog(audit: Auditoria, detalhe: AuditDetalhe) {
        return this.dialog.open(ModalDetalheAlteracoesComponent, {
            data: {entryType: audit.tipoCadastro, entityModel: detalhe.data},
            minWidth: "80vw",
            maxWidth: "80vw",
            maxHeight: "99vh",
            autoFocus: false,
        });
    }

    showDiff(audit: Auditoria) {
        this.auditoriaService.findChanges(audit.idAuditoria,audit.tipoCadastro).subscribe(data =>{
            return this.dialog.open(ModalAlteracoesComponent, {
                data,
                minWidth: "80vw",
                maxWidth: "80vw",
                maxHeight: "99vh",
                autoFocus: false,
            });
        })
    }

    disableDiff(audit: Auditoria) {
        return audit.acao.id === 'INSERT'|| audit.acao.id === 'DELETE';
    }

    updateItensPerPage(number: any) {
        this.form.controls.itensPerPage.setValue(number);
        this.page$.next(1);
    }
}
